module.exports = __webpack_public_path__ + "img/daqar2.1a0e25ce.jpg";